// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nNs8","controls":"styles_controls__1jDxw","charLimit":"styles_charLimit__3TQfd","input":"styles_input__1lnfB","send":"styles_send__16QPe"};